/** Production API base; avoid baking dev URLs into Lambda bundles. */
function resolveApiBaseUrl(): string {
  const raw = import.meta.env.VITE_API_BASE_URL ?? "/api/v1";
  let s = String(raw).trim().replace(/\/$/, "");
  if (import.meta.env.PROD && /localhost|127\.0\.0\.1/i.test(s)) {
    s = "/api/v1";
  }
  return s || "/api/v1";
}

const rawBase = resolveApiBaseUrl();

/**
 * Vite public path prefix for static assets (e.g. /provision-template.csv in dev).
 * When base is / or ./, keep empty so href becomes /provision-template.csv
 */
const stageFromViteBase = () => {
  const b = import.meta.env.BASE_URL ?? "/";
  if (b === "/" || b === "./") {
    return "";
  }
  return String(b).replace(/\/$/, "");
};

export const env = {
  apiBaseUrl: String(rawBase).replace(/\/$/, ""),
  useMocks: import.meta.env.VITE_USE_MOCKS === "true",
  /** Directory health stays reachable at /directory-health for superusers, but the link is hidden unless enabled. */
  showDirectoryHealthLink: import.meta.env.VITE_SHOW_DIRECTORY_HEALTH === "true",
  stagePrefix: stageFromViteBase()
};
